module.exports = __webpack_public_path__ + "static/img/gaozhongwuli2.42096ce7.jpg";